module.exports = __webpack_public_path__ + "img/P150T_weapon_60.f5069975.png";